import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

// Images & Icons
import CapitalProjectsIcon from 'assets/icons/capital-projects.svg';
import ProjectsKPIsIcon from 'assets/icons/projects-kpi.svg';
import TroubledProjectsIcon from 'assets/icons/troubled-projects.svg';
import DelayedProjectsIcon from 'assets/icons/delayed-projects.svg';
import SuspendedProjectsIcon from 'assets/icons/suspended-projects.svg';
import WithdrawnProjectsIcon from 'assets/icons/withdrawn-projects.svg';
import TimeoverrunProjectsIcon from 'assets/icons/timeoverrun-projects.svg';
import ProjectsPerformanceIcon from 'assets/icons/projects-performance.svg';
import ContractorAnalysisIcon from 'assets/icons/contractor-analysis.svg';
import MapSPIcon from 'assets/icons/map-sp.svg';

//light theme
import CapitalProjectsIconLight from "assets/icons/capital-projects-light.svg";
import ProjectsKPIsIconLight from "assets/icons/projects-kpi-light.svg";
import TroubledProjectsIconLight from "assets/icons/troubled-projects-light.svg";
import DelayedProjectsIconLight from "assets/icons/delayed-projects-light.svg";
import SuspendedProjectsIconLight from "assets/icons/suspended-projects-light.svg";
import WithdrawnProjectsIconLight from "assets/icons/withdrawn-projects-light.svg";
import TimeoverrunProjectsIconLight from "assets/icons/timeoverrun-projects-light.svg";
import ProjectsPerformanceIconLight from "assets/icons/projects-performance-light.svg";
import ContractorAnalysisIconLight from "assets/icons/contractor-analysis-light.svg";
import MapSPIconLight from "assets/icons/map-sp-light.svg";

function Navigation() {
    let navigate = useNavigate();

    function redirectPage ( route ) {
        navigate( route );
    }

    const selectedTheme = useSelector((state) => state.globalConfig.theme);

  
  return (
    <aside className='navigation'>
        <nav>
        <ul>
          <li
            onClick={() => {
              redirectPage("/");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={CapitalProjectsIcon} alt="#" />
                ) : (
                  <img src={CapitalProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Capital Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/project-kpis");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={ProjectsKPIsIcon} alt="#" />
                ) : (
                  <img src={ProjectsKPIsIconLight} alt="#" />
                )}

                <span className="tooltip">Project KPIs</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/troubled-projects-dashboard");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={TroubledProjectsIcon} alt="#" />
                ) : (
                  <img src={TroubledProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Troubled Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/delayed-projects-dashboard");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={DelayedProjectsIcon} alt="#" />
                ) : (
                  <img src={DelayedProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Delayed Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/suspended-projects-dashboard");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={SuspendedProjectsIcon} alt="#" />
                ) : (
                  <img src={SuspendedProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Suspended Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/withdrawn-projects-dashboard");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={WithdrawnProjectsIcon} alt="#" />
                ) : (
                  <img src={WithdrawnProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Withdrawn Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/time-overrun-projects");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={TimeoverrunProjectsIcon} alt="#" />
                ) : (
                  <img src={TimeoverrunProjectsIconLight} alt="#" />
                )}
                <span className="tooltip">Timeoverrun Projects</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/projects-performance-dashboard");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={ProjectsPerformanceIcon} alt="#" />
                ) : (
                  <img src={ProjectsPerformanceIconLight} alt="#" />
                )}
                <span className="tooltip">Projects Performance</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/contractor-analysis");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={ContractorAnalysisIcon} alt="#" />
                ) : (
                  <img src={ContractorAnalysisIconLight} alt="#" />
                )}
                <span className="tooltip">Contractor Analysis</span>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              redirectPage("/change-order");
            }}
          >
            <div className="icon-container-outside">
              <div className="icon-container-inside">
                {selectedTheme === "dark" ? (
                  <img src={MapSPIcon} alt="#" />
                ) : (
                  <img src={MapSPIconLight} alt="#" />
                )}
                <span className="tooltip">Change Order</span>
              </div>
            </div>
          </li>
        </ul>
        </nav>
    </aside>
  )
}

export default Navigation